import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BookmarkSimple, BookOpen, Heart, User as UserIcon } from "@phosphor-icons/react";

const items = [
  { to: "/perfil/lista/collection", label: "Coleção", Icon: BookmarkSimple },
  { to: "/perfil/lista/read", label: "Lidos", Icon: BookOpen },
  { to: "/perfil/lista/wishlist", label: "Desejados", Icon: Heart },
  { to: "/perfil", label: "Perfil", Icon: UserIcon, end: true },
];

export default function MobileBottomBar() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-bottom-bar"
    >
      <div className="grid grid-cols-4 h-16">
        {items.map(({ to, label, Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`bottom-bar-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors ${
                isActive ? "text-[#E63946]" : "text-zinc-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={22} weight={isActive ? "fill" : "bold"} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
